import React from "react";
import { FlexListItem, ListItem } from '@common-fe/common-fe';
import { toString } from "lodash";

import { ContactResponseModel } from '@/modules/employer/components/SetupEmployer/ContactsSecurity/AddEditContactsSecurityModal/ContactSecurity.types';
import useResendVerificationForContact from '@/modules/employer/components/SetupEmployer/ContactsSecurity/AddEditContactsSecurityModal/hooks/useResendVerificationForContact';
import { convertSecondsToMinutes } from '@/utils/modifiers/convertSecondsToMinutes';

interface Props {
  contact: ContactResponseModel;
  row: ListItem;
  isViewContactsAvailable?: boolean;
  disableOptions?: boolean;
  onEdit: (contact: ContactResponseModel) => void;
  onView: (contact: ContactResponseModel) => void;
  onOpenLoginHistory: (contactId?: number) => void;
}

const ContactsSecurityTableListItem: React.FC<Props> = ({ row, contact, isViewContactsAvailable, onEdit, onView, onOpenLoginHistory, disableOptions }) => {
  const { remainingTime, isDisabled, handleResend } = useResendVerificationForContact({
    contactId: toString(contact?.id),
    value: toString(contact?.email),
    valueKey: toString(contact?.id),
  });

  return (
    <FlexListItem
      onPick={isViewContactsAvailable ? () => onView(contact) : undefined}
      key={row.id}
      id={row.id}
      fields={row.fields}
      options={disableOptions ? undefined : [
        {
          name: 'Edit',
          onClick: () => onEdit(contact),
        },
        {
          name: 'View authentication history',
          onClick: () => onOpenLoginHistory(contact?.id),
        },
        ...contact?.is_email_verified ? [] : [{
          name: `Resend verification ${remainingTime > 0 ? `(${convertSecondsToMinutes(remainingTime)})` : ''}`,
          onClick: handleResend,
          disabled: isDisabled,
        }],
      ]}
    />
  );
};

export default ContactsSecurityTableListItem;
